/* eslint-disable */
import productCategoryAPI from "./data";

const state = {
  list: [],
  edit: null
};

// getters
const getters = {
  loading(state) {
    return state.loadingCount === 0;
  }
};

// actions
const actions = {
  init: (context, refresh = false) => {
    if (!!context.state.list["results"] && !refresh) {
      return context.state.list;
    }
    return productCategoryAPI.list(context).then(data => {
      context.commit("SET_LIST", data);
    });
  },
  update: (context, productCategory, continueEdit = false) => {
    return productCategoryAPI.update(context, productCategory).then(data => {
      context.dispatch("init", true);
      if (continueEdit) {
        context.commit("SET_EDIT", data);
      } else {
        context.commit("SET_EDIT", null);
      }
      return data;
    });
  },
  insert: (context, productCategory) => {
    return productCategoryAPI.insert(context, productCategory).then(data => {
      context.dispatch("init", true);
      return data;
    });
  },
  get: (context, productCategoryKey) => {
    context.commit("SET_LOADING", true);
    return productCategoryAPI.get(context, productCategoryKey).then(data => {
      context.commit("SET_EDIT", data);
      return data;
    });
  }
};

// mutations
const mutations = {
  SET_LIST(state, list) {
    state.list = list;
  },
  SET_EDIT(state, edit) {
    state.edit = edit;
  }
};

export default { namespaced: true, state, getters, actions, mutations };
